var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1471",
    d: "M7.75,2A3.758,3.758,0,0,0,4,5.75v13.5A3.758,3.758,0,0,0,7.75,23h13.5a.75.75,0,0,0,.75-.75V5.75A.75.75,0,0,0,21.25,5H19V2.75A.75.75,0,0,0,18.25,2Zm0,1.5H17.5v12H7.75a3.71,3.71,0,0,0-2.25.771V5.75A2.229,2.229,0,0,1,7.75,3.5ZM19,6.5h1.5v15H7.75a2.25,2.25,0,0,1,0-4.5h10.5a.75.75,0,0,0,.75-.75Z",
    transform: "translate(-4 -2)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1477",
    d: "M19.225,24H8.746a.75.75,0,1,0,0,1.5H19.225a.75.75,0,1,0,0-1.5Z",
    transform: "translate(-4.996 -7.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookColored);
export default __webpack_public_path__ + "static/media/book-colored.dde64d9684d21102c5cc89a8e2a9cff6.svg";
export { ForwardRef as ReactComponent };